import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encodeUri',
  standalone: false,
})
export class EncodeUriPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return encodeURI(value);
  }
}
